import 'ui-core/plugins/slide/js/slide';

var isTablet = true;

// Override the control function to fix the issue where buttons stop working after first click
UX.slide.control = function () {
    const $body = $('body');
    const slide = UX.slide;

    $body.on('click', '.w-slide__btn', function (e) {
        // Fixed: removed $(this).off('click') that was destroying click handlers
        if (slide.isQueue && slide.isMobile) {
            e.stopImmediatePropagation();
            return false;
        }
        slide.isQueue = true;

        if ($(this).hasClass('disable')) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        if ($(this).hasClass('slide-active')) {
            e.stopPropagation();
            e.preventDefault();
            slide.addTransition();
            slide.$toggle = $(this);
            slide.$target = $(slide.$toggle.data('slide-target'));
            slide.back = false;

            if ($(this).is('[id*=pane-pcw]') && UX.tab.check.empty($(this))) {
                setTimeout(function () {
                    slide.on.show(e);
                }, 3000);
            } else {
                slide.on.show(e);
            }
        }
    });

    $body.on('click', '.w-slide__back, .w-slide__hide', function (e) {
        if ($(this).hasClass('w-slide__back')) {
            e.preventDefault();
        }

        slide.back = true;
        slide.on.hide(e);
    });
};

UX.slide.additionalResponsive = function () {
    $(document).on('screen-xs-on', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        isTablet = false;
        UX.slide.backIcon = 'icon-arrow_l';
    });

    $(document).on('screen-xs-off', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        isTablet = true;
        UX.slide.backIcon = 'icon-close_thin';
    });
};

UX.slide.on._showSlide = function () {
    if (isTablet) {
        if (!UX.slide.nested) {
            UX.slide.$elements.addClass('js--open');
        } else {
            UX.slide.$contents.addClass('js--open');
        }
        // Reset isQueue for tablet mode since there's no transition
        UX.slide.isQueue = false;
    } else {
        const slideWidth = '100%';

        let $slidedDiv = UX.slide.$elements;
        if (UX.slide.nested || UX.slide.multi) {
            $slidedDiv = UX.slide.$contents;
        }

        if (!UX.slide.$elements.hasClass('js--open') && UX.slide.multi) {
            $slidedDiv = $('[class*=nested--], .w-slide');
        }

        $slidedDiv
            .css('transform', 'translateX(-' + slideWidth + ')')
            .off()
            .one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
                e.stopPropagation();
                UX.slide.isQueue = false;
                UX.slide.removeTransition();
            });
        UX.slide.$elements.addClass('js--open');
        UX.slide.on.additionalShowSlide();
    }
    UX.slide.$slideinfo.show().addClass('js--open');
};
UX.slide.on._hideSlide = function () {
    let updateTarget;
    if (!UX.slide.nested) updateTarget = UX.slide.$elements;
    else updateTarget = UX.slide.$contents;

    if (isTablet) {
        updateTarget.removeClass('js--open');
        // Also remove js--open from the parent element if not nested
        if (!UX.slide.nested) {
            UX.slide.$elements.removeClass('js--open');
        }
    } else {
        updateTarget.css('transform', 'translateX(0vw)');
    }

    // Hide and remove js--open class from title/slideinfo
    UX.slide.$slideinfo.hide().removeClass('js--open');

    updateTarget.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
        if (UX.slide.back) $(this).removeAttr('style');
        if (!UX.slide.nested) UX.slide.$contents.empty();
        else if (UX.slide.nested) $(this).remove();
        // Only unbind transition events, not all events
        UX.slide.$elements.off('transitionend webkitTransitionEnd oTransitionEnd');
    });
};

UX.slide.on.additionalOff = function (e) {
    // Additional cleanup when slide is completely closed
    UX.slide.$slideinfo.hide().removeClass('js--open');

    // Reset the back icon based on device type
    UX.slide.backIcon = isTablet ? 'icon-close_thin' : 'icon-arrow_l';
    UX.slide.setBackLabel();
};

UX.slide.backLabel = '';
UX.slide.backIcon = 'icon-close_thin';
UX.slide.setBackLabel = function () {
    UX.slide.$back.html('<i class="' + UX.slide.backIcon + '" aria-hidden="true"></i>');
};
